import { useInstance } from 'intact-vue';
import { useReceive } from '../../hooks/useReceive';
import { minMaxStep } from '../spinner/useValue';
import { error } from 'intact-shared';
import { isEqualArray } from '../utils';
import { useState } from '../../hooks/useState';
export function useValue(getStep, getDragging) {
  var instance = useInstance();
  var showValue = useState(instance.get('value'), isEqualValue);
  useReceive(['min', 'max', 'step', 'value'], function () {
    if (getDragging()) return;
    fixValue(instance.get('value'), true);
  });
  instance.on('$change:value', function (newValue, oldValue) {
    if (getDragging()) return;
    instance.trigger('change', newValue, oldValue);
  });
  function isEqualValue(newValue, oldValue) {
    return newValue === oldValue || isEqualArray(newValue, oldValue);
  }
  function fixValue(value, fixShowValue) {
    var fixedValue = getFixedValue(value);
    showValue.set(fixShowValue ? fixedValue : value);
    setValue(fixedValue);
  }
  function setValue(value) {
    if (isEqualValue(value, instance.get('value'))) return;
    instance.set({
      value: value
    });
  }
  function getFixedValue(value) {
    var _instance$get = instance.get(),
      min = _instance$get.min,
      range = _instance$get.range;
    var fixedValue;
    if (range) {
      if (!Array.isArray(value)) {
        var tmp = fix(value);
        fixedValue = [tmp, tmp];
      } else {
        fixedValue = [fix(value[0]), fix(value[1])];
      }
    } else {
      fixedValue = fix(value);
    }
    return fixedValue;
  }
  function fix(value) {
    var _instance$get2 = instance.get(),
      max = _instance$get2.max,
      forceStep = _instance$get2.forceStep;
    var _getStep = getStep(value),
      step = _getStep[0],
      min = _getStep[1];
    if (min > max) {
      if (process.env.NODE_ENV !== 'production') {
        error("[Slider] min must less than or equal to max, but got min: " + min + " max: " + max);
        return 0;
      }
    }
    return minMaxStep(value, min, max, forceStep ? step : null);
  }
  function onSpinnerChange(v) {
    showValue.set(v);
    instance.set({
      value: v
    });
  }
  function onLeftSpinnerChange(v) {
    var secondValue = showValue.value[1];
    onSpinnerChange([v, Math.max(v, secondValue)]);
  }
  function onRightSpinnerChange(v) {
    var firstValue = showValue.value[0];
    onSpinnerChange([Math.min(v, firstValue), v]);
  }
  function triggerChangeEvent(oldValue) {
    var _instance$get3 = instance.get(),
      value = _instance$get3.value;
    if (isEqualValue(value, oldValue)) return;
    instance.trigger('change', value, oldValue);
  }
  return {
    showValue: showValue,
    onSpinnerChange: onSpinnerChange,
    onLeftSpinnerChange: onLeftSpinnerChange,
    onRightSpinnerChange: onRightSpinnerChange,
    setValue: setValue,
    triggerChangeEvent: triggerChangeEvent,
    fixValue: fixValue
  };
}